import {
  ReturnRequestLineItemNewVariantDto,
  ReturnRequestLineItemVariantDto,
} from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@babackapp/ui/components/hover-card";

type SimpleExchangeHoverCardProps = {
  initialVariant: ReturnRequestLineItemVariantDto;
  newVariant?: ReturnRequestLineItemNewVariantDto;
};

export function SimpleExchangeHoverCard({
  children,
  initialVariant,
  newVariant,
}: React.PropsWithChildren<SimpleExchangeHoverCardProps>) {
  const t = useTranslation();

  const newVariantLabel =
    [newVariant?.option1, newVariant?.option2, newVariant?.option3]
      .filter(Boolean)
      .join(", ") || newVariant?.productTitle;

  return (
    <>
      <span className="text-sm text-foreground font-medium">
        {newVariantLabel}
      </span>

      <HoverCard>
        <HoverCardTrigger>{children}</HoverCardTrigger>
        <HoverCardContent>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col">
              <span className="text-muted-foreground font-medium text-xs">
                {t("returnDetail.update.initialVariant")}
              </span>
              <p className="text-sm text-foreground font-medium">
                {initialVariant.title}
              </p>
            </div>
            <div className="flex flex-col">
              <span className="text-muted-foreground font-medium text-xs">
                {t("returnDetail.update.newVariant")}
              </span>
              <p className="text-sm text-foreground font-medium">
                {newVariantLabel}
              </p>
            </div>
          </div>
        </HoverCardContent>
      </HoverCard>
    </>
  );
}
